import PendingApprovalsNotice from "../components/PendingApprovalsNotice";
import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

function AdminDashboard({ userRole }) {
  const [updateMessage, setUpdateMessage] = useState({
    msg: "",
    status: false
  });

  function updateDatabase() {
    axios.post(`${API_URL}/bucket/build-structure`, {}, {
      headers: {
        "Content-Type": "application/json",
        token: localStorage.getItem("token")
      }
    })
      .then(() => {
        setUpdateMessage({
          msg: "Databasen är uppdaterad.",
          status: true
        });
      })
      .catch(() => {
        setUpdateMessage({
          msg: "Uppdateringen misslyckades.",
          status: false
        });
      });
  }

  const adminActions = [
    { to: "/admin-operations", label: "Driftöversikt" },
    { to: "/admin-analytics", label: "Analysöversikt" },
    { to: "/audit-trail", label: "Revisionslogg" },
    { to: "/email-status", label: "E-poststatus" },
    { to: "/admin-groups", label: "Föreningsgrupper" },
    { to: "/user-management", label: "Användarhantering" },
    { to: "/video-metadata", label: "Redigera videometadata" },
    { to: "/login-log", label: "Visa inloggningslogg" }
  ];

  return (
    <div className="flex flex-col items-center px-3">
      <div className="w-full max-w-3xl py-4">
        <div className="theme-card">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">Administration</p>
          <h1 className="mt-2 text-lg font-bold text-slate-800">Adminöversikt</h1>
          <p className="mt-2 text-sm text-slate-600">
            Välj vilket administrationsområde du vill arbeta med.
          </p>

          <PendingApprovalsNotice userRole={userRole} />
          <button
            className="theme-button-secondary mt-5 w-full text-left"
            onClick={() => updateDatabase()}
          >
            Uppdatera databas
          </button>
          {updateMessage.msg && (
            <p className={`mt-2 w-full text-center ${updateMessage.status ? "theme-alert-success" : "theme-alert-error"}`}>
              {updateMessage.msg}
            </p>
          )}

          <div className="mt-5 space-y-4">
            {adminActions.map((action) => (
              <Link key={action.to} to={action.to} className="block">
                <div className="theme-panel flex w-full items-center justify-between text-left hover:-translate-y-0.5 hover:border-sky-300 hover:shadow-md">
                  <span className="text-base font-semibold text-slate-800">{action.label}</span>
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/80 text-sky-700 shadow-sm ring-1 ring-sky-100">
                    <svg className="h-4 w-4" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M6 3.5L10.5 8L6 12.5L7.4 13.9L13.3 8L7.4 2.1L6 3.5Z" />
                    </svg>
                  </span>
                </div>
              </Link>
            ))}

            <Link to="/reg-user" className="block">
              <div className="theme-panel-muted flex w-full items-center justify-between text-left hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md">
                <span className="text-base font-semibold text-slate-800">Snabbval: Lägg till ny användare</span>
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-700 shadow-sm ring-1 ring-slate-200">
                  <svg className="h-4 w-4" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M6 3.5L10.5 8L6 12.5L7.4 13.9L13.3 8L7.4 2.1L6 3.5Z" />
                  </svg>
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
